import Seo from "../../components/Seo.tsx";
import LegalPage from "./LegalPage.tsx";

export default function Privacy() {
  return (
    <>
    <Seo title="Privacy Policy" description="How BeAdoré Candles collects, uses, and protects your personal information." path="/privacy" noIndex />
    <LegalPage
      eyebrow="What We Hold Quietly"
      title="Privacy Policy"
      updatedAt="April 2026"
    >
      <p>
        BeAdoré (<em>"we," "us," "our"</em>) values your privacy. This Privacy
        Policy explains what personal information we collect, how we use it,
        who we share it with, and the choices you have. It applies to your use
        of <strong>beadorecandles.com</strong> and any related services.
      </p>

      <h2>1 · What we collect</h2>
      <p>We only ask for what we need to run the atelier.</p>
      <ul>
        <li>
          <strong>Contact information.</strong> When you place an order or
          compose a horoscope candle, we collect your first name, email
          address, and (for candles) your birth date.
        </li>
        <li>
          <strong>Shipping address.</strong> Collected by Stripe at checkout
          and passed to us so we can ship your order.
        </li>
        <li>
          <strong>Payment details.</strong> Card numbers and CVCs are collected
          directly by <strong>Stripe, Inc.</strong> on Stripe-hosted pages —
          BeAdoré never sees or stores your full card number. We only receive
          metadata (last four digits, expiry, confirmation status) for
          fulfillment.
        </li>
        <li>
          <strong>Site interactions.</strong> Basic server logs (IP address,
          request time, user agent) via Cloudflare. Your shopping cart is
          stored locally in your browser (localStorage) and never transmitted
          to our servers until you check out.
        </li>
      </ul>

      <h2>2 · How we use it</h2>
      <ul>
        <li>To process and ship your orders.</li>
        <li>To compose your horoscope candle reading (first name, birth date).</li>
        <li>
          To email you order receipts and occasional brand updates (the
          BeAdoré Private Letter List).
        </li>
        <li>To respond to your messages and support requests.</li>
        <li>
          To comply with tax, accounting, and consumer-protection obligations.
        </li>
      </ul>

      <h2>3 · Who we share with</h2>
      <p>
        We do not sell your personal information. We share only what is
        necessary with trusted service providers who help us run the site:
      </p>
      <ul>
        <li>
          <strong>Stripe, Inc.</strong> — payment processing. See Stripe's
          privacy policy at https://stripe.com/privacy.
        </li>
        <li>
          <strong>Google LLC (Gemini API)</strong> — the AI model that composes
          your horoscope candle reading. Your first name, birth date, and
          derived zodiac sign are sent to Google for the sole purpose of
          generating that reading. Google does not use the input to train its
          models. See https://ai.google.dev/privacy.
        </li>
        <li>
          <strong>Resend, Inc.</strong> — the service we use to send order
          receipts and the Private Letter List. See https://resend.com/privacy.
        </li>
        <li>
          <strong>Cloudflare, Inc.</strong> — our hosting, CDN, and DNS
          provider. Cloudflare may log standard request metadata. See
          https://www.cloudflare.com/privacypolicy/.
        </li>
      </ul>
      <p>
        We will also disclose information if required by law, subpoena, or to
        protect the rights, property, or safety of BeAdoré, our customers, or
        others.
      </p>

      <h2>4 · How long we keep it</h2>
      <p>
        Order records are retained for as long as legally required (typically
        seven years for tax purposes). Horoscope candle compositions and
        associated email addresses are retained until you ask us to delete
        them. You can unsubscribe from the Private Letter List at any time
        using the link at the bottom of any email we send.
      </p>

      <h2>5 · Your rights</h2>
      <p>
        Depending on where you live, you may have the right to:
      </p>
      <ul>
        <li>Access the personal information we hold about you.</li>
        <li>Correct inaccurate information.</li>
        <li>Request deletion of your information.</li>
        <li>Opt out of marketing emails.</li>
        <li>
          (If you are a resident of California, Colorado, Virginia, Connecticut,
          or Utah.) Additional rights under your state's consumer privacy law,
          including the right to opt out of "sale" or "sharing" of personal
          information — which BeAdoré does not do.
        </li>
      </ul>
      <p>
        To exercise any of these rights, email{" "}
        <a href="mailto:hello@beadorecandles.com" className="underline">
          hello@beadorecandles.com
        </a>{" "}
        and we will respond within thirty (30) days.
      </p>

      <h2>6 · Children</h2>
      <p>
        BeAdoré is not directed to children under 13. We do not knowingly
        collect personal information from anyone under 13. If you believe we
        have inadvertently collected such information, please contact us and we
        will promptly delete it.
      </p>

      <h2>7 · Security</h2>
      <p>
        We take reasonable steps to protect your information. Payment data is
        encrypted in transit via TLS and processed by Stripe. Personal
        information we store is held in Cloudflare's D1 database with
        restricted access. No system is perfectly secure, however — if you
        believe your account has been compromised, please contact us
        immediately.
      </p>

      <h2>8 · Changes</h2>
      <p>
        We may update this Privacy Policy from time to time. We will post the
        revised version here and update the "Last updated" date at the top.
      </p>

      <h2>9 · Contact</h2>
      <p>
        Questions or requests? Write to us at{" "}
        <a href="mailto:hello@beadorecandles.com" className="underline">
          hello@beadorecandles.com
        </a>
        .
      </p>
    </LegalPage>
    </>
  );
}
